<template>
  <q-scroll-area style="height: calc(100% - 150px); margin-top: 150px; border-right: 1px solid #ddd">
    <q-list padding separator dense>

      <q-item
        clickable
        v-ripple
        to="/choose-business"
        dense
      >
        <q-item-section avatar>
          <q-icon name="corporate_fare" />
        </q-item-section>

        <q-item-section>
          <strong>Empresas</strong>
        </q-item-section>
      </q-item>

      <q-expansion-item
        icon="edit_calendar"
        label="Gestiones"
        default-opened
        class="text-weight-bold"
      >
        <q-list separator dense>
          <q-item
            clickable
            v-ripple
            :inset-level="1"
            v-for="gestionItem in gestiones"
            :key="gestionItem.id"
            :active="gestion.id == gestionItem.id"
            @click="setGestion(gestionItem)"
          >

            <q-item-section class="text-weight-regular">
              {{gestionItem.gestion}}
            </q-item-section>
          </q-item>
        </q-list>

      </q-expansion-item>

      <q-expansion-item
        icon="edit_note"
        label="Solicitudes"
        default-opened
        class="text-weight-bold"
      >
        <q-list separator dense>
          <q-item
            clickable
            v-ripple
            :inset-level="1"
            to="/solicitudes"
          >
            <q-item-section class="text-weight-regular">
              Usuario
            </q-item-section>
          </q-item>
          <q-item
            clickable
            v-ripple
            :inset-level="1"
            to="/autorizaciones"
            v-if="user.rol_id == 3"
          >
            <q-item-section class="text-weight-regular">
              Autorización
            </q-item-section>
          </q-item>
          <q-item
            clickable
            v-ripple
            :inset-level="1"
            to="/revisor"
            v-if="(user.rol_id == 4 || user.revisor) && user.global_view !== 1"
          >
            <q-item-section class="text-weight-regular">
              Revisor
            </q-item-section>
          </q-item>

          <q-item
            clickable
            v-ripple
            :inset-level="1"
            to="/aprobador"
            v-if="user.apr_parcial && user.global_view !== 1"
          >
            <q-item-section class="text-weight-regular">
              Aprobador Parcial
            </q-item-section>
          </q-item>
        </q-list>

      </q-expansion-item>

      <q-item
        clickable
        v-ripple
        to="/settings"
      >
        <q-item-section avatar>
          <q-icon name="settings" />
        </q-item-section>

        <q-item-section>
          <strong>Configuración</strong>
        </q-item-section>

      </q-item>

      <q-item
        clickable
        v-ripple
        @click="logout()"
      >
        <q-item-section avatar>
          <q-icon name="logout" />
        </q-item-section>

        <q-item-section>
          <strong>Cerrar sesión</strong>
        </q-item-section>

        <q-item-section avatar>
          <q-spinner-bars
            color="white"
            size="2em"
            v-if="loading"
          />
        </q-item-section>

      </q-item>

      <q-item
        v-ripple
      >
        <q-item-section>
          <strong>v{{util.getVersion()}}</strong>
        </q-item-section>
      </q-item>

    </q-list>
  </q-scroll-area>

  <!-- <q-img class="absolute-top" :src="`${url}${empresa.logo}`" style="height: 150px" v-if="empresa"> -->
  <q-img class="absolute-top" :src="`${url}${empresa.logo}`" style="height: 150px" v-if="empresa" @error="errorHandler">
    <div class="absolute-bottom bg-transparent-2" style="width: 100%; height: 100%">
      <div class="text-weight-bold q-pt-xl">{{user.nombre}}</div>
      <div>{{user.usuario}}</div>
    </div>
  </q-img>
</template>

<script>
import env from '../../config/env'
import {ref} from 'vue'
import { useQuasar } from 'quasar'
import axios from 'axios'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import util from '../plugins/util'

export default {
  setup () {
    // Variables reactivas y no reactivas
    const $q = useQuasar()
    const router = useRouter()
    const store = useStore()

    const url = ref(env.SERVER_URL)
    const loading = ref(false)
    const empresa = $q.localStorage.getItem('empresa')
    const gestion = $q.localStorage.getItem('gestion')
    const gestiones = ref([])
    const user = ref(store.state.auth.user)

    // Métodos y funciones
    const getGestiones = async () => {
      let res = await axios.get('gestion')
      gestiones.value = res.data
    }

    const setGestion = (data) => {
      $q.localStorage.set('gestion', data)
      router.go()
    }

    const logout = async () => {
      loading.value = true
      await store.dispatch('auth/logout')
      loading.value = false
      router.push({ name: 'login' })
    }

    const errorHandler = (e) => {
      e.target.src = 'https://cdn.quasar.dev/img/material.png'
    }

    // Creación del componente
    if (util.verifyBusiness()) {
      getGestiones()
    } else if (user.value.usuario == 'rjofre' || user.value.usuario == 'admin') {
      router.push({name: 'indexPresidencia'})
    } else if (user.value.usuario == 'mardiles'){
      router.push({name: 'indexGlobalUsuario'})
    } else {
      router.push({name: 'choose-business'})
    }
    

    // Retorno de variables al template
    return {
      url,
      empresa,
      gestion,
      gestiones,
      setGestion,
      logout,
      user,
      loading,
      errorHandler,
      util
    }
  }
}
</script>

<style>

</style>